import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../styles/adminCDN.css";
import "../styles/admin.css";
import "../styles/Affiliate.css";
import ApprovePopup from "../components/auth/ApprovePopup";
import ScrollToTop from "../pages/ScrollToTop";
import EmailVerifySuccess from "../components/client/EmailVerifySuccess";
import AffiliateFooter from "../components/affiliat/AffiliateFooter";
import AffiliateHeader from "../components/affiliat/AffiliateHeader";
import AffiliateSidebar from "../components/affiliat/AffiliateSidebar";
import DashboardA from "../pages/Affiliate/DashboardA";
import Transaction from "../pages/Affiliate/Transaction/Transaction";
import PayoutTransaction from "../pages/Affiliate/PayoutTransaction/PayoutTransaction";
import Withdraw from "../pages/Affiliate/Profile/Withdraw";
import PayoutTransactionAdd from "../pages/Affiliate/PayoutTransaction/PayoutTransactionAdd";
import PayoutTransactionEdit from "../pages/Affiliate/PayoutTransaction/PayoutTransactionEdit";
import PayoutTransactionView from "../pages/Affiliate/PayoutTransaction/PayoutTransactionView";
import Profile from "../pages/Affiliate/Profile/Profile";

function Affiliate({ handleLogout }) {
  return (
    <div>
      <BrowserRouter basename="/dealsmachiVendor">
        <ApprovePopup />
        <div className="d-flex flex-column flex-lg-row bg-surface-secondary">
          <AffiliateSidebar handleLogout={handleLogout} />
          <div className="flex-grow-1 h-screen overflow-y-auto">
            <AffiliateHeader />
            <main className="pt-3" style={{ backgroundColor: "#f2f2f2" }}>
              <ScrollToTop />
              <div style={{ minHeight: "90vh" }}>
                <Routes>
                  <Route path="/" element={<DashboardA />} />
                  <Route path="*" element={<DashboardA />} />

                  {/* Transaction */}
                  <Route path="/transaction" element={<Transaction />} />

                  {/* Profile */}
                  <Route
                    path="/profile"
                    element={<Profile handleLogout={handleLogout} />}
                  />

                  {/* Withdraw Account */}
                  <Route
                    path="/withdraw-account"
                    element={<Withdraw handleLogout={handleLogout} />}
                  />

                  {/*  Payout Transaction */}
                  <Route
                    path="/payout-transaction"
                    element={<PayoutTransaction />}
                  />
                  <Route
                    path="/payout-transaction/add"
                    element={<PayoutTransactionAdd />}
                  />
                  <Route
                    path="/payout-transaction/edit/:id"
                    element={<PayoutTransactionEdit />}
                  />
                  <Route
                    path="/payout-transaction/view/:id"
                    element={<PayoutTransactionView />}
                  />

                  <Route
                    path="/emailverifysuccess"
                    element={<EmailVerifySuccess />}
                  />
                </Routes>
              </div>
              <AffiliateFooter />
            </main>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default Affiliate;
